<app-form-manager *ngIf="!!nextDestionation"
                  formPlugin="back-button-form"
                  [params]="formParams"
                  (canceled)="onClick()">
</app-form-manager>
